<template lang="pug">
table-base.study-result-detail-table
  //- ヘッダー部
  table-row-base.study-result-detail-table__row-header.text-medium
    table-header-base.study-result-detail-table__row-header__cell.align-left
      slot(name='problemNumberHeader')
    table-header-base.study-result-detail-table__row-header__cell.align-center
      slot(name='questionNumberHeader')
    table-header-base.study-result-detail-table__row-header__cell.align-center
      slot(name='correctSymbolHeader')
    //- 正答率は一時的に非表示
    //- table-header-base.study-result-detail-table__row-header__cell.align-center
    //-   slot(name='correctRateHeader')
  template(v-for='detail in studyResultDetails')
    //- 一覧表示部
    table-row-base.study-result-detail-table__row.text-small.font-medium
      table-data-base.study-result-detail-table__row__cell
        .study-result-detail-table__row__cell__text-left {{ detail.problemNumberText }}
      table-data-base.study-result-detail-table__row__cell
        .study-result-detail-table__row__cell__text {{ detail.questionNumberText }}
      table-data-base.study-result-detail-table__row__cell
        .study-result-detail-table__row__cell__text {{ detail.correctSymbol }}
      //- 正答率は一時的に非表示
      //- table-data-base.study-result-detail-table__row__cell
      //-   .study-result-detail-table__row__cell__text {{ detail.correctRate }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import { StudyResultDetailType } from '@/models/studyResultDetailModel'

/**
 * テスト結果詳細テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
  },
})
export default class StudyResultDetailTable extends Vue {
  // テスト結果詳細表示情報
  @Prop()
  studyResultDetails!: StudyResultDetailType[]
}
</script>

<style lang="stylus" scoped>
.study-result-detail-table
  width 100%
  table-layout fixed

  &__row-header,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 20px

      &__text
        display flex
        justify-content center

    &:hover
      background var(--color-manager-list__hover)
</style>
